<template>
  <div class="p-8 bg-[#F8FAFC] min-h-screen">
    <nav class="flex justify-between items-center mb-8">
      <button @click="$emit('close')" class="flex items-center gap-2 text-gray-500 hover:text-gray-900 transition-colors font-bold text-xs uppercase tracking-widest">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" /></svg>
        Retour au NOC
      </button>
      <div class="flex gap-4">
        <span class="px-4 py-2 bg-red-50 text-red-600 rounded-xl text-[10px] font-black uppercase border border-red-100">Ticket #{{ ticketId }} — En cours</span>
      </div>
    </nav>

    <div class="grid lg:grid-cols-12 gap-8">
      
      <div class="lg:col-span-8 space-y-6">
        
        <div class="bg-white rounded-[2.5rem] p-8 shadow-sm border border-gray-100">
          <div class="flex items-start justify-between mb-8">
            <div class="flex items-center gap-6">
              <div class="w-20 h-20 bg-gray-900 rounded-[2rem] flex items-center justify-center shadow-2xl">
                <svg class="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="1.5" d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" /></svg>
              </div>
              <div>
                <h2 class="text-3xl font-black text-gray-900 tracking-tighter">{{ incident.deviceAlias }}</h2>
                <p class="text-dimotec-orange font-bold uppercase text-xs tracking-[0.2em]">{{ incident.clientName }} — Agence Montpellier</p>
              </div>
            </div>
            <div class="text-right">
              <p class="text-[10px] font-black text-gray-400 uppercase">Code Erreur</p>
              <p class="text-2xl font-mono font-black text-red-600">{{ incident.errorCode }}</p>
            </div>
          </div>

          <div class="grid grid-cols-3 gap-6 py-6 border-t border-gray-50">
            <div>
              <p class="text-[10px] font-black text-gray-400 uppercase mb-1">Version APK</p>
              <p class="text-sm font-bold">v2.4.1 (Stable)</p>
            </div>
            <div>
              <p class="text-[10px] font-black text-gray-400 uppercase mb-1">IP Locale</p>
              <p class="text-sm font-bold font-mono">192.168.1.42</p>
            </div>
            <div>
              <p class="text-[10px] font-black text-gray-400 uppercase mb-1">Dernier Reboot</p>
              <p class="text-sm font-bold">08 Jan 2026 - 09:12</p>
            </div>
          </div>
        </div>

        <div class="bg-white rounded-[2.5rem] p-8 shadow-sm border border-gray-100">
          <h3 class="text-lg font-black mb-6">Journal d'intervention</h3>
          
          <div class="space-y-6">
            <div class="grid grid-cols-2 gap-4">
              <div class="space-y-2">
                <label class="text-[10px] font-black text-gray-400 uppercase">Catégorie de panne</label>
                <select class="w-full bg-gray-50 border-none rounded-2xl py-4 px-6 font-bold text-sm outline-none focus:ring-2 focus:ring-dimotec-orange/20">
                  <option>Mécanique (Imprimante)</option>
                  <option>Logiciel (APK)</option>
                  <option>Réseau (WebSocket)</option>
                </select>
              </div>
              <div class="space-y-2">
                <label class="text-[10px] font-black text-gray-400 uppercase">Temps passé</label>
                <input type="text" placeholder="ex: 15 min" class="w-full bg-gray-50 border-none rounded-2xl py-4 px-6 font-bold text-sm outline-none">
              </div>
            </div>

            <div class="space-y-2">
              <label class="text-[10px] font-black text-gray-400 uppercase">Actions menées & Observations</label>
              <textarea rows="4" class="w-full bg-gray-50 border-none rounded-[2rem] py-6 px-8 text-sm font-medium placeholder:text-gray-300 focus:ring-2 focus:ring-dimotec-orange/20" placeholder="Décrivez les manipulations effectuées..."></textarea>
            </div>

            <div class="flex items-center justify-between p-6 bg-blue-50 rounded-3xl border border-blue-100">
              <div class="flex items-center gap-4">
                <div class="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center text-white">
                  <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                </div>
                <div>
                  <p class="text-xs font-black text-blue-900 uppercase">Clôture du ticket</p>
                  <p class="text-[11px] text-blue-700">La borne sera automatiquement remise en ligne sur le NOC.</p>
                </div>
              </div>
              <button class="px-8 py-3 bg-blue-600 text-white rounded-xl font-black text-[10px] uppercase tracking-widest shadow-lg shadow-blue-200">Enregistrer & Clôturer</button>
            </div>
          </div>
        </div>
      </div>

      <div class="lg:col-span-4 space-y-6">
        
        <div class="bg-gray-900 rounded-[2.5rem] p-8 text-white shadow-2xl">
          <h3 class="text-xs font-black uppercase tracking-widest text-dimotec-orange mb-8">Remote Actions (Force)</h3>
          
          <div class="space-y-3">
            <button class="w-full flex items-center justify-between p-4 bg-white/5 rounded-2xl hover:bg-white/10 transition-all group">
              <span class="text-xs font-bold">Redémarrer l'APK</span>
              <svg class="w-5 h-5 text-gray-500 group-hover:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" /></svg>
            </button>
            <button class="w-full flex items-center justify-between p-4 bg-white/5 rounded-2xl hover:bg-white/10 transition-all group">
              <span class="text-xs font-bold">Nettoyer cache d'impression</span>
              <svg class="w-5 h-5 text-gray-500 group-hover:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
            </button>
            <button class="w-full flex items-center justify-between p-4 bg-white/5 rounded-2xl hover:bg-white/10 transition-all group">
              <span class="text-xs font-bold">Capture d'écran Live</span>
              <svg class="w-5 h-5 text-gray-500 group-hover:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" /><path stroke-width="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
            </button>
          </div>

          <div class="mt-8 pt-8 border-t border-white/5">
            <p class="text-[10px] font-black text-gray-500 uppercase tracking-widest mb-4 text-center">Diagnostic Thermique</p>
            <div class="bg-black/40 rounded-3xl p-6 text-center">
              <p class="text-[10px] text-gray-400 mb-1 uppercase font-bold">Température Tête</p>
              <p class="text-3xl font-black text-green-400">34°C</p>
              <p class="text-[9px] text-green-800 font-bold mt-2 uppercase">Statut : Optimal</p>
            </div>
          </div>
        </div>

        <div class="bg-white rounded-[2.5rem] p-8 border border-gray-100 shadow-sm">
          <h3 class="text-[10px] font-black uppercase tracking-widest text-gray-400 mb-6">Incidents récents (Site)</h3>
          <div class="space-y-4">
            <div v-for="h in 2" :key="h" class="flex gap-4">
              <div class="w-1 h-8 bg-gray-100 rounded-full"></div>
              <div>
                <p class="text-xs font-bold text-gray-900">Perte de connexion 4G</p>
                <p class="text-[10px] text-gray-400 font-medium">Le 05/01/26 - Résolu</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ticketId: { default: "2026-AF42" }
  },
  data() {
    return {
      incident: {
        deviceAlias: 'Borne #042 - Montpellier Vente',
        clientName: 'DIMOTEC DIAGNOSTICS',
        errorCode: 'PRINTER_JAM',
        type: 'Hardware'
      }
    }
  }
}
</script>